import { Box } from '@mui/material';
import React from 'react';
import { CurrentPlan } from 'core/constants/enums/CurrentPlan.ts';
import BaseTypography from 'core/components/typography/BaseTypography';
import { reusableStyles } from 'core/layouts/ui-blocks/ReusableStyles';

// import assets
import { ReactComponent as ProPlanIcon } from 'core/assets/svg/pricing-page/plan.svg';
import { ReactComponent as MaxPlanIcon } from 'core/assets/svg/pricing-page/max-plan-home.svg';
import { upgradeToStyles } from 'core/layouts/components/upgrade-to/UpgradeToStyles';

// assets

export default function UpgradeTo({ userProfile, isProfileDataLoading }) {
	return isProfileDataLoading || false ? (
		<Box
			key="loading-upgradeto-container"
			sx={[
				reusableStyles.skeletonLoaderStyles,
				reusableStyles.flexRowWithGap(4),
				{
					padding: '16px',
					width: '131px',
					borderRadius: '15px',
				},
			]}
		>
			<BaseTypography
				key="loading-upgrade-button"
				variant="b1_regular"
				styles={reusableStyles.skeletonLoaderStyles}
			/>
		</Box>
	) : (
		<Box
			id="upgradeto-container"
			sx={[reusableStyles.flexRowWithGap(4), upgradeToStyles.upgradeToContainer]}
		>
			{userProfile?.currentPlan?.toLowerCase() === CurrentPlan.FREE ? (
				<ProPlanIcon />
			) : userProfile?.currentPlan?.toLowerCase() === CurrentPlan.PRO ? (
				<MaxPlanIcon />
			) : null}

			<BaseTypography key="upragde-button" variant="b2_caption" styles={{ color: 'colors.light3' }}>
				Upgrade Plan
			</BaseTypography>
		</Box>
	);
}
